import {
    Container,
    InteractionEvent,
    SvgGraphics,
} from '@tencent/alloy-renderer';

export interface IGuideLineGraphicsProps {
    position: number;
    color: string;
    isUiComponent: boolean;
    canEdit?: boolean;
    showGuides?: boolean;
    updateGuide(e: InteractionEvent): void;
    handleContextMenu(e: InteractionEvent): void;
}

/**
 * 参考线图形组件基类
 */
export abstract class BaseGuideLine extends Container {
    protected lineComponent: SvgGraphics;
    protected props: IGuideLineGraphicsProps;
    protected hotEventLength = 6;
    protected defaultLineColor = '#A7A7A7';
    protected defaultAlpha = 0.8;

    public constructor(props: IGuideLineGraphicsProps) {
        super();
        this.props = props;
    }

    protected handleMouseDown = (e) => {
        e.stopPropagation?.();
        e.preventDefault?.();
        this.props.updateGuide(e);
    };

    protected handleContextMenu = (e) => {
        e.preventDefault?.();
        e.stopPropagation?.();
        this.props.handleContextMenu(e);
    };

    protected handleDoubleClick = (e: InteractionEvent) => {
        e.stopPropagation?.();
        e.preventDefault?.();
    };

    abstract renderGuideLine(position: number, color: string);
}
